import React, { Component } from 'react';
import { View, Text, StyleSheet, Picker, Image, Dimensions, TextInput, ScrollView, TouchableOpacity, ActivityIndicator } from 'react-native'
import Ionicon from 'react-ionicons'
import './Support.css'
import {Modal, ConfirmModal} from '../components/Common';
import FakeData from '../fake-data';
import TextareaAutosize from 'react-autosize-textarea';
import { BlockObject } from '../components/Settings';

const {height, width} = Dimensions.get("window");

export default class Support extends Component {
    constructor(props){
        super(props);
        this.state = {
            messages: [],
            isLoading: true,
            active: false,
            startDate: false,
            endDate: false,
            isShowAttachment: false,
            isShown: false,
            searchValue: "",
            feedbackFilter: '',
            activeKey: 'all',
            tokens: {
                none: ""
            },
            texts: {
                none: ""
            }
        }
    }

    componentDidMount(){
        this._isMounted = true;
        this.getData();
        this.chats = {};
        if(!this.props.isAdmin){
            FakeData.$("#root").css({
                "overflow":"hidden"
            });
        }
    }

    componentWillUnmount(){
        this._isMounted = false;
        if(!this.props.isAdmin){
            FakeData.$("#root").css({
                "overflow":"auto"
            });
        }
    }

    unblock = (id, string) => {
        const _unblock = window.confirm(string==="show account posts"?`Are you sure you want to ${string} again?`:`Are you sure you want to ${string} this content?`);
        const _that = this;
        if(!_unblock){
            return;
        }

        FakeData.post(FakeData.apiURL+"/admin/unblock/"+id, {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if(!_that._isMounted){
                    return;
                }
                _that.getData();
            },
            error(error) {
                if(!_that._isMounted){
                    return;
                }
            }
        }, true, "", null)
    }

    getData = () => {
        const _that = this;
        const _data = this.props.isAdmin?{
            id: false
        }:{
            id: FakeData.you().id,
            type: FakeData.you().type
        }

        FakeData.post(FakeData.apiURL+"/admin/support/get", _data, {
            headers: {
                "Content-Type": "application/json"
            },
            method: 'post',
            success(res){
                if(_that._isMounted){
                    res.sort((a,b)=>{
                        const _a = new Date(a.last_mod).getTime();
                        const _b = new Date(b.last_mod).getTime();
            
                        return _b - _a;
                    })
                    res.forEach((item, i) => {
                        _that.state.texts[item._id] = _that.state.texts[item._id]?_that.state.texts[item._id]:""
                        _that.state.tokens[item._id] = _that.state.tokens[item._id]?_that.state.tokens[item._id]:Date.now()+item._id
                    });
                    
                    _that.setState({ messages: res, isLoading: false, active:!_that.state.active && res[0]?res[0]:_that.state.active, texts: _that.state.texts});
                    
                    const _active = res.filter((item,i)=>{
                        return item._id == _that.state.active._id;
                    });

                    if(_active[0] && _active[0].messages.length!==_that.state.active.messages.length){
                        _that.setState({ active:_active[0]});
                    }
                    setTimeout(()=>{
                        _that.getData();
                    }, 3000);
                }
            },
            error(err){
                _that.setState({ messages: [], isLoading: false });
            }
        })
    }

    closeThread = (data, callback = () => {})=> {
        const {_id} = data;
        const {active} = this.state;
        const _that = this;
        const _cb = () => {
            callback();
        }

        FakeData.post(FakeData.apiURL+"/admin/support/close/"+_id, {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if(!_that._isMounted){
                    return;
                }
                if(res.error){
                    FakeData.alert(res.message);
                } else{
                    active.is_closed = true;
                    _that.setState({ active });
                    FakeData.alert(res.message);
                }
                _cb()
            },
            error(error) {
                if(!_that._isMounted){
                    return;
                }
            }
        }, true, "", null)
    }

    parseMessages = (msgs = []) => {
        const timeList = [];
        const messageTimeList = {};
        msgs.forEach((m, i) => {
            var ago = FakeData.moment(m.date).calendar();
            if (!FakeData.inArray(ago, timeList)) {
                timeList.push(ago);
                messageTimeList[ago] = [];
            }
        });

        msgs.forEach((m, i) => {
            var ago = FakeData.moment(m.date).calendar();
            FakeData.listify(messageTimeList[ago]).push(m);
        });

        return {
            times: timeList,
            _messages: messageTimeList
        };
    }

    render() {
        const {active, texts, tokens, startDate, endDate, feedbackFilter, isShown, activeKey, searchValue,isShowAttachment} = this.state;
        const {times, _messages} = this.parseMessages(active?active.messages:[]);
        let messages = this.state.messages.filter((item, i)=>{
            if(activeKey==='all'){
                return true;
            }
            return item.type === activeKey;
        }).filter((item, i)=>{
            if(!this.props.isAdmin){
                return true;
            } else if(activeKey==='feedback'){
                const _itemDate = new Date(item.date).getTime();
                if(!this.state.startDate || !this.state.endDate){
                    return item.body.toLowerCase().indexOf(feedbackFilter.toLowerCase()) > -1;
                }
                return item.body.toLowerCase().indexOf(feedbackFilter.toLowerCase()) > -1 && (
                    _itemDate >= this.state.startDate && _itemDate <= this.state.endDate
                )
            } else{
                const _itemDate = new Date(item.date).getTime();
                if(!this.state.startDate || !this.state.endDate){
                    return true;
                } else{
                return _itemDate >= this.state.startDate && _itemDate <= this.state.endDate
                }
            }
        })
        return (
        <View style={{
            flex: 1,
            backgroundColor: "#fff",
            maxHeight: "80vh",
            height: "80vh"
        }}>
            <SupportHeader 
                openAttachment={()=>{
                    this.setState({ isShowAttachment: true });
                }}
                onStartDateChange={(startDate)=>{
                    this.setState({ startDate });
                }}
                onEndDateChange={(endDate)=>{
                    this.setState({ endDate });
                }}
                Side={
                    <View style={{
                        backgroundColor: 'rgba(255,255,255,0.3)',
                        height: 40,
                        margin: 10,
                        borderRadius: 2,
                        overflow: 'hidden',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                        <TextInput onChange={(searchValue)=>{
                            this.setState({ searchValue: searchValue.target.value });
                        }} value={this.state.searchValue} style={{
                            flex:1,
                            padding: 10,
                            backgroundColor: "white",
                        }} placeholder="Search" placeholderTextColor="#000" />
                        <Ionicon icon="md-search" color={"white"} style={{
                            width: 40,
                            height: 20
                        }} />
                    </View>
                }
                Header={activeKey==='feedback'?
                    <select value={feedbackFilter} style={{
                        border: 'none',
                        height: '40px',
                        backgroundSize: '40px',
                        paddingLeft: 10,
                        paddingRight: 50,
                        overflow: 'hidden'
                    }} onChange={(e)=>{
                        this.setState({feedbackFilter : e.target.value });
                    }}>
                        {
                            ["Nudity", "Violence", "Harassment", "Suicide or Self-Injury", "False News", "Spam", "Unauthorized Sales", "Hate Speech"].map((item, i)=>{
                                return(
                                    <option value={item} key={i}>{item}</option>
                                )
                            })
                        }
                    </select>:null
                }
                isAdmin={this.props.isAdmin?true:false}
                active={active}
                FilterView={
                    <View style={{
                        height: 40,
                        backgroundColor: '#fff',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                        {
                            [
                                {label: 'All', key: 'all'},
                                {label:'Reports',key:'bug'},
                                {label:'Feedback', key:'feedback'},
                                {label:'Suggestions', key:'suggestion'}
                            ].map((item, i)=>{
                                return(
                                    <TouchableOpacity key={item.key} style={{
                                        paddingHorizontal: 10,
                                        paddingVertical: 5,
                                        borderRightWidth: item.key === 'suggestion'? 0: 1,
                                        borderRightColor: '#345',
                                        height: 40,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        backgroundColor: activeKey===item.key?"#345":"#fff"
                                    }} onPress={()=>{
                                        this.setState({ activeKey: item.key });
                                    }}>
                                        <Text style={{
                                           color: activeKey===item.key?"#fff":"#000"
                                        }}>{item.label}</Text>
                                    </TouchableOpacity>
                                )
                            })
                        }
                    </View>
                }
            />
            <SupportBody
                Content={this.state.isLoading?
                        <Loading /> :
                        this.state.messages.length === 0 ?
                            <Empty icon="md-chatboxes" label={"No messages yet"} />
                            : !this.state.active ?
                                <Empty icon="md-chatboxes" label={"Select message from the left panel"} /> :

                                <View style={{
                                    flex: 1,
                                    position: 'relative'
                                }}>
                                    <ScrollView key={active._id} scrollEventThrottle={1} onScroll={(e) => {
                                        if (this.chats[active._id]) {
                                            try {
                                                this.chats[active._id]['position'] = e.target.valueOf()
                                                console.log(e.target.valueOf())
                                            } catch (error) {

                                            }
                                        }
                                    }} ref={(ref) => {
                                        if (ref && !this.chats[active._id]) {
                                            ref.scrollToEnd({
                                                animated: true
                                            });
                                            this.chats[active._id] = {
                                                ref,
                                                isScrolled: true,
                                                position: 0
                                            }
                                        } else if (ref && this.chats[active._id]) {
                                            //ref.scrollTo({ x: 0, y: this.chats[active._id]['position'] })
                                        }
                                    }} className="chat-right-view-body-chats-list" style={{
                                        flex: 1,
                                        paddingVertical: 10
                                    }}>
                                        <div className="chat-right-view-body-chats-list-items">
                                            <h2 style={{
                                                marginBottom: 0
                                            }}>Topic based on {active.context}</h2>
                                            <h4 style={{
                                                margin: 0
                                            }} dangerouslySetInnerHTML={{__html:FakeData.br(active.body)}}/>
                                        </div>
                                        {
                                            times.map((time, i) => {
                                                const _msgs = _messages[time];
                                                return (
                                                    <div key={time} className="chat-right-view-body-chats-list-items">
                                                        {this.is && <span className={"chat-msg-time"}>{time}</span>}
                                                        {
                                                            _msgs.map((message) => {
                                                                return (
                                                                    <SupportMessage message={message} key={message._id} />
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                        {active.is_closed &&
                                            <div className="chat-right-view-body-chats-list-items">
                                                <span className={"chat-msg-time"}>{"Closed by admin"}</span>
                                            </div>
                                        }
                                    </ScrollView>
                                    {!active.is_closed &&
                                        <View style={{
                                            flexDirection: 'row',
                                            borderTopColor: "#ccc",
                                            borderTopWidth: 1
                                        }}>
                                            <TextareaAutosize key={tokens[active._id]} rows={1} defaultValue={texts[active._id]} placeholder={"Write something..."} style={{
                                                flex: 1,
                                                resize: "none",
                                                border: "none",
                                                padding: "10px",
                                                minHeight: "36px",
                                                borderRight: "1px solid #ccc",
                                            }} onChange={(e) => {
                                                texts[active._id] = e.target.value
                                                this.setState({ texts });
                                            }} />
                                            <Ionicon color={texts[active._id].length === 0?"#aaa":"#4ac"} icon={"md-send"} fontSize="36px" style={{
                                                width: 36,
                                                height: 36,
                                                margin: 10,
                                                cursor: texts[active._id].length === 0?"":"pointer"
                                            }} onClick={()=>{
                                                if(texts[active._id].length === 0){
                                                    return;
                                                }

                                                let user = !this.props.isAdmin ?
                                                active.user : {
                                                    id: 0,
                                                    type: "F",
                                                    email: FakeData.support().email,
                                                    name: "Admin"
                                                }
                                                const _data = {
                                                    user,
                                                    body: texts[active._id],
                                                    support_id: active._id
                                                };

                                                const cb = (message) => {
                                                    texts[active._id] = "";
                                                    tokens[active._id] = Date.now()+active._id;
                                                    active.messages.push(message);
                                                    this.setState({ texts, tokens, active });
                                                    try {
                                                        this.chats[active._id].ref.scrollToEnd({animated: true})
                                                    } catch (error) {
                                                        
                                                    }
                                                }

                                                const _that = this;

                                                FakeData.post(FakeData.apiURL+"/admin/support/reply", _data, {
                                                    headers: {
                                                        "Content-Type": "application/json"
                                                    },
                                                    method: 'post',
                                                    success(res){
                                                        if(_that._isMounted){
                                                            cb(res)
                                                        }
                                                    },
                                                    error(err){
                                                        
                                                    }
                                                });
                                            }}/>
                                        </View>
                                    }
                                    {this.props.isAdmin &&
                                        <TouchableOpacity style={{
                                            width: 50,
                                            height: 50,
                                            borderRadius: 100,
                                            position: 'absolute',
                                            right: 0,
                                            top: 0,
                                            margin: 10,
                                            backgroundColor:"#345",
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }} activeOpacity={1}>
                                            <Ionicon onClick={()=>{
                                                this.setState({ isDelete: true });
                                            }} icon="md-close" color="rgba(255,255,255,0.7)" fontSize="25px" style={{
                                                width: 25,
                                                height: 25
                                            }} />
                                        </TouchableOpacity>
                                    }
                                    {(active.hasScreenshot || (active.hasObject && active.block && this.props.isAdmin)) &&
                                        <TouchableOpacity style={{
                                            width: 50,
                                            height: 50,
                                            borderRadius: 100,
                                            position: 'absolute',
                                            right: 0,
                                            top: 0,
                                            margin: 10,
                                            marginTop: 70,
                                            backgroundColor:"#345",
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }} activeOpacity={1}>
                                            <Ionicon onClick={()=>{
                                                if(active.hasScreenshot){
                                                    this.setState({ isShowAttachment: true });
                                                    return;
                                                } else if(active.hasObject){
                                                    this.setState({ isShown: !isShown });
                                                }
                                                
                                            }} icon="md-attach" color="rgba(255,255,255,0.7)" fontSize="25px" style={{
                                                width: 25,
                                                height: 25
                                            }} />
                                            {isShown && active.hasObject && !active.block.object.error &&
                                                <div style={{
                                                    position: 'absolute',
                                                    top: "100%",
                                                    marginTop: 10,
                                                    marginRight: 10,
                                                    width: "300px",
                                                    right: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 1,
                                                    boxShadow: "1px 1px 2px #555"
                                                }}>
                                                    <BlockObject isSupport conf={active.block} unblock={this.unblock.bind(this)}/>
                                                </div>
                                            }
                                        </TouchableOpacity>
                                    }
                                </View>
                }
                Side={this.state.isLoading?
                    <Loading /> :
                    messages.filter((message, i)=>{
                        return message.body.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
                    }).length === 0 ?
                        <Empty icon="md-chatboxes" label={"No messages found"} />
                        :
                        <ScrollView style={{
                            flex: 1
                        }}>
                            {
                                messages.filter((message, i)=>{
                                    return message.body.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
                                }).map((message, i) => {
                                    return (
                                        <View key={message._id} style={{
                                            borderBottomColor: "#ddd",
                                            borderBottomWidth: 1,
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            backgroundColor: active && active._id === message._id?'#eee':''
                                        }}>
                                            <Ionicon color="#345" icon={message.type === "bug" ? "md-bug" :message.type==="feedback"?"md-warning":"md-bulb"} fontSize="30px" style={{
                                                width: 40,
                                                height: 40,
                                                padding: 10,
                                                marginLeft: 10,
                                            }} />
                                            <div style={{
                                                flex: 1,
                                                padding: 10,
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }} onClick={() => {
                                                this.setState({ active: message });
                                            }}>
                                                <Text numberOfLines={3} style={{
                                                    paddingVertical: 5,
                                                    paddingHorizontal: 10,
                                                    color: "black",
                                                    fontWeight: '500',
                                                    fontSize: 14
                                                }}>{message.body}</Text>
                                                {message.is_closed &&
                                                    <span style={{
                                                        padding: "5px 10px",
                                                        backgroundColor: message.is_closed ? "#ddd" : "#4a5",
                                                        color: "white",
                                                        display: 'inline',
                                                        width: 'auto',
                                                        textAlign: 'center',
                                                        fontWeight: '500',
                                                        borderRadius: 2,
                                                        fontSize: 13,
                                                    }}>{message.is_closed ? "Closed" : "Open"}</span>
                                                }
                                            </div>
                                        </View>
                                    )
                                })
                            }
                        </ScrollView>
                }
                
            />
                {isShowAttachment &&
                    <AttachmentModal isOpen={isShowAttachment} image={FakeData.apiURL+"/" + active.file} onClose={() => {
                        this.setState({ isShowAttachment: false });
                    }} />
                }
                {this.state.isDelete &&
                    <ConfirmModal message="Are you sure you want to close this thread?<br/>" isOpen={this.state.isDelete} data={active}
                        onOkay={(data) => {
                            this.closeThread(data, ()=>{
                                this.setState({
                                    isDelete: false,
                                })
                            })
                        }}
                        onCancel={() => {
                            this.setState({
                                isDelete: false,
                            })
                        }} />
                }
        </View>
        )
    }
};

const Loading = (props) => {
    return(
        <View style={{flex: 1, alignItems: 'center',justifyContent: 'center',}}>
            <ActivityIndicator color="#345" />
        </View>
    )
}

class SupportMessage extends Component{
    constructor(props){
        super(props)
        this.state = {

        }
    }

    render(){
        const {message} = this.props;
        return(
            <View className={message.user_id===FakeData.you().id && message.user_type === FakeData.you().type?"support-msg you":"support-msg"} style={{
                
            }}> 
                <span className={"msg-author"}>{message.user_name}</span>
                <span className={"msg-time"}>{FakeData.moment(message.date).fromNow()}</span>
                <span className={message.user_id===FakeData.you().id && message.user_type === FakeData.you().type?"msg":"msg you"}>{message.body}</span>
            </View>
        )
    }
}

const Empty = (props) => {
    return(
        <View style={{flex: 1, alignItems: 'center',justifyContent: 'center',}}>
            {props.icon &&
                <Ionicon color={props.color?props.color:"#ccc"} icon={props.icon?props.icon:"md-document"} fontSize="50px" style={{
                    width: 60,
                    height: 60,
                    padding: 10,
                }} />
            }
            <Text style={{
                color: props.color?props.color:"#ccc"
            }}>{props.label?props.label:"Empty"}</Text>
        </View>
    )
}

const AttachmentModal = ({onClose, isOpen, image, ...props}) => {
    return(
        <Modal onClose={onClose} isOpen={isOpen}>
            <View className={"add-place file-popup"} style={{
                width: "75vw",
                height: "75vh",
                backgroundColor: 'black',
            }}>
                <Image style={{
                    resizeMode: "contain",
                    height: "100%"
                }} source={{uri:image}} />
                <View style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 40,
                    paddingHorizontal: 10,
                    zIndex: 1
                }}>
                    <ButtonIcon
                        icon={"md-download"}
                        iconColor={"#eee"}
                        iconFontSize={"15px"}
                        iconStyle={{
                            width: 15,
                            height: 15,
                        }}

                        text={"Download"}
                        textStyle={{
                            color:"#eee",
                            fontSize: "13px"
                        }}
                        onClick={()=>{
                            let a = document.createElement("a");
                            a.download = true;
                            a.className = "_download-attach"
                            a.target = "_blank"
                            a.href = image;
                            document.body.appendChild(a);
                            a.click();
                            FakeData.$("._download-attach").remove();
                        }}
                        style={{
                            marginRight: 10,
                        }}
                    />
                </View>
            </View>
        </Modal>
    )
}

const ButtonIcon = ({onClick, icon, iconColor, iconFontSize, style, iconStyle, text, textStyle, ...props}) => {
    return(
        <div style={{
            padding: 5,
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            width: 'auto',
            ...style}} onClick={onClick}>
            <Ionicon icon={icon} style={{marginRight:'5px',...iconStyle}} fontSize={iconFontSize} color={iconColor}/>
            <span style={{...textStyle}}>{text}</span>
        </div>
    )
}

const SupportHeader = ({Side, Header, onEndDateChange, onStartDateChange, FilterView, ...props}) => {
    return(
        <View style={{
            backgroundColor: "#4ac",
            flexDirection: 'row'
        }}>
            <View style={{
                flex: 1.05
            }}>{Side}</View>
            <View style={{
                flex: 3,
                alignItems: 'center',
                paddingHorizontal: 20,
                flexDirection: 'row'
            }}>
                {!props.isAdmin &&
                    <Text style={{
                        color: "rgba(255,255,255,0.7)",
                        fontSize: 30,
                        flex: 1,
                        fontWeight: '6000'
                    }}>Support Inbox</Text>
                }
                {props.isAdmin &&
                    <div style={{
                        marginRight: 30,
                        flex: 1
                    }}>{Header}</div>
                }
                {props.isAdmin &&
                    <div style={{
                        marginRight: 30,
                        color: '#fff'
                    }}>From <input onChange={(e)=>{
                        const {value} = e.target;
                        const _data = new Date(value).getTime();
                        if(onStartDateChange){
                            onStartDateChange(_data)
                        }
                    }} style={{
                        border: "none",
                        color: '#000',
                        height: 40
                    }} type='date'/></div>
                }
                {props.isAdmin &&
                    <div style={{
                        marginRight: 30,
                        color: '#fff'
                    }}> To <input onChange={(e)=>{
                        const {value} = e.target;
                        const _data = new Date(value).getTime();
                        if(onEndDateChange){
                            onEndDateChange(_data)
                        }
                    }} style={{
                        border: "none",
                        color: '#000',
                        height: 40
                    }} type='date'/></div>
                }
                {props.isAdmin &&
                    <div>
                        {FilterView}
                    </div>
                }
            </View>
        </View>
    )
}

class SupportObject extends Component{
    constructor(p){
        super(p)
        this.state = {
            isShown: true,
        }
    }

    render(){
        return(
            <div style={{
                position: 'relative',
                height: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Ionicon onClick={()=>{
                    this.setState({ isShown: !this.state.isShown });
                }} icon="md-attach" color="rgba(255,255,255,0.7)" fontSize="25px" style={{
                    width: 25,
                    height: 25
                }} />
                {this.state.isShown &&
                    <div style={{
                        position: 'absolute',
                        top: "100%",
                        width: "300px",
                        right: 0,
                        height: "150px",
                        background: "#fff",
                        zIndex: 1
                    }}>

                    </div>
                }
            </div>
        )
    }
}

const SupportBody = ({Side, Content, ...props}) => {
    return(
        <View style={{
            flex: 1,
            backgroundColor: "#fff",
            flexDirection: 'row'
        }}>
            <View style={{
                flex: 1,
                borderRightWidth: 1,
                borderRightColor: "#ccc"
            }}>{Side}</View>
            <View style={{
                flex: 3
            }}>{Content}</View>
        </View>
    )
}



// WEBPACK FOOTER //
// ./src/pages/Support.js